<template>
  <div class="homePage">

    <h1 class="top_logo_wrapper">
      <img src="../assets/logo.jpg" class="top_logo" alt="ADLCJ - Association pour le Développement de la Langue et de la Culture Japonaises" />
    </h1>

    <section class="welcomeSection">
      <div class="welcomeWrapper">
        <img src="../assets/image/components/seigaiha_three.svg" class="seigaihaTopRight" alt="" aria-hidden="true" />
        <h2 class="welcomeFR">
          Bienvenue au site officiel de l'ADLCJ,<br />
          Association pour le Développement de la Langue et de la Culture Japonaises
        </h2>
        <h2 class="welcomeJA">ADLCJ 日本語・日本文化振興協会公式サイトへようこそ</h2>
        <img src="../assets/image/components/seigaiha_three.svg" class="seigaihaBottomLeft" alt="" aria-hidden="true" />
      </div>
    </section>

    <section class="mainSection">
      <div class="photosArea">
        <img src="../assets/image/kingyo_home.svg" class="kingyoDeco" alt="" aria-hidden="true" />
      </div>

      <div class="buttonsArea">
        <ButtonPrimary
          variant="red"
          label="Hoshuko"
          to="/ecole"
          class="redLabel"
        />
        <ButtonPrimary
          variant="gold"
          label="Cours de japonais pour adultes"
          to="/cours-japonais"
        />
      </div>
    </section>

    <section class="whoSection">
      <ButtonSecondary
        :label="$t('adlcj.h1')"
        variant="grey"
        to="/adlcj"
      />
    </section>

  </div>
</template>

<script>
import ButtonPrimary from "./ButtonPrimary.vue";
import ButtonSecondary from "./ButtonSecondary.vue";

export default {
  name: "HomeFR",
  components: { ButtonPrimary, ButtonSecondary },
};
</script>

<style lang="scss" scoped>
.homePage {
  position: relative;
  overflow: hidden;
  padding-bottom: 60px;
}

.top_logo_wrapper {
  margin: 0;
  padding: 0;
  line-height: 0;
}

.top_logo {
  margin-top: 1rem;
  width: 200px;
  height: auto;
}

.welcomeSection {
  padding: 40px 20px 20px;
  display: flex;
  justify-content: center;
  overflow: visible;
  margin-bottom: 20px;
}

.welcomeWrapper {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  width: 100%;
  max-width: 1200px;
}

.welcomeFR {
  grid-column: 1 / 4;
  grid-row: 1;
  font-weight: 600;
  font-size: 26px;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  margin-top: 0;
  text-align: center;
  color: $textColor;
  padding: 0 20px;
}

.welcomeJA {
  grid-column: 1 / 4; // toute la largeur (était 2 / 4)
  grid-row: 2;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 0;
  font-size: 26px;
  text-align: center;
  padding: 0 20px;
}

.seigaihaTopRight {
  grid-column: 3;
  grid-row: 1;
  width: 150px;
  align-self: start;
  justify-self: end;
  margin-top: -20px; // ajuste la position verticale
}

.seigaihaBottomLeft {
  grid-column: 1;
  grid-row: 2;
  width: 150px;
  align-self: end;
  justify-self: start;
}

.mainSection {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  max-width: 1200px;  // un peu plus large pour donner de l'espace
  margin: 40px auto 0;
  padding: 0 20px;
}

.photosArea {
  display: flex;
  align-items: center;  
}

.buttonsArea {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-self: start;
  justify-self: end;
  width: 370px;
  margin-top: 20px;
}

.whoSection {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

@media (max-width: 600px) {
  .top_logo {
    width: 120px;
  }

  .welcomeSection {
    padding: 20px 10px 10px;
  }

  .welcomeFR {
    font-size: 17px;
    padding: 0 10px;
  }

  .welcomeJA {
    font-size: 15px;
    padding: 0 10px;
  }

  .seigaihaTopRight,
  .seigaihaBottomLeft {
    width: 70px;
  }

  .mainSection {
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
  }

  .photosArea {
    width: 100%;
    height: auto;
    order: 2;

    img {
      width: 100%;
      height: auto;
    }
  }

  .buttonsArea {
    order: 1;
  }

  .buttonsArea {
    width: 100%;
    max-width: 340px;
    gap: 10px;
  }

  .whoSection {
    margin-top: 20px;
  }
}
</style>
